import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ModelOption {
  optionCode: string;
  optionIndicator: string;
  optionDescription: string;
  selection: string;
}

export interface ModelOptionsResponse {
  errorMessage: string;
  modelOptions: ModelOption[];
  modelExteriorOptions: ModelOption[];
  modelInteriorOptions: ModelOption[];
}

@Injectable({
  providedIn: 'root',
})
export class ModelOptionsService {
  constructor(private readonly http: HttpClient) {}
  getModelOptions(modelCode: string): Observable<ModelOptionsResponse> {
    const url = '/model-options';

    const headers = new HttpHeaders({
      accept: 'application/json',
      'Content-Type': 'application/json',
    });
    const body = { modelCode };

    return this.http.post<ModelOptionsResponse>(url, body, { headers });
  }
}
